<template>
  <TasksPage />
</template>

<script setup lang="ts">
import TasksPage from "shared-ui/pages/TasksPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    layout: "AppLayout",
    headerTitleKey: "common.your_tasks",
  },
});
</script>
